import { render, staticRenderFns } from "./BecomePatron.vue?vue&type=template&id=64b7c40a&scoped=true&"
import script from "./BecomePatron.vue?vue&type=script&lang=js&"
export * from "./BecomePatron.vue?vue&type=script&lang=js&"
import style0 from "./BecomePatron.vue?vue&type=style&index=0&id=64b7c40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b7c40a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GiftPatron: require('/home/bitrix/frontend/components/forms/GiftPatron.vue').default,MtInput: require('/home/bitrix/frontend/components/form/MtInput.vue').default,MtSwitch: require('/home/bitrix/frontend/components/form/MtSwitch.vue').default,MtCheckbox: require('/home/bitrix/frontend/components/form/MtCheckbox.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
